import {
    Box,
    Flex,
    FormLabel,
    Heading,
    IconButton,
    Input,
    InputGroup,
    InputLeftElement,
    Link,
    Stack,
    Textarea,
    Tooltip,
    useClipboard,
    useColorModeValue,
    useToast,
    VStack,
} from '@chakra-ui/react';
import React, { useRef } from 'react';
import { BsGithub, BsLinkedin, BsPerson, BsTelephoneFill, BsWhatsapp } from 'react-icons/bs';
import { MdEmail, MdOutlineEmail } from 'react-icons/md';
import emailjs from '@emailjs/browser';
import { useState } from 'react';

export default function ContactForm() {
    const toast = useToast()
    const [flag, setFlag] = useState(false);
    const { hasCopied, onCopy } = useClipboard('kohadashish27@gmail.com');
    const { hasCopiedMobile, onCopyMobile } = useClipboard('8668794792');

    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('default_service', 'template_tc15tjo', form.current, '1aXE5RrbH1aspNNLy')
            .then((result) => {
                console.log(result.text);
                if (result.text === "OK") {
                    setFlag(!flag);
                }
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset();
    };
    const handleSend = () => {

        toast({
            title: 'Email Send Successfully.',
            description: "We will reach to as soon as possible",
            status: 'success',
            position: "top",
            duration: 9000,
            isClosable: true,
        })

    }
    return (
        <Box>
            <Flex
                id="contact"
               
                align="center"
                justify="center"
              
            >
                <Box
                    borderRadius="lg"
                    m={{ base: 5, md: 16, lg: 10 }}
                    p={{ base: 5, lg: 16 }}>
                    <Box>
                        <VStack spacing={{ base: 4, md: 8, lg: 20 }}>
                            <Heading
                                fontSize={{ base: "100px", sm: "160px", md: "200px",lg:"250px" }}
                                color={useColorModeValue("gray.300", "gray.600")}
                                // className={styles.contactHeading}
                                fontFamily="'Playfair Display', serif"
                                // mb="200px"
                                mb={{ base: "-30px", sm: "-120px", md: "-200px" }}
                            >
                                Contact
                            </Heading>
                            <Stack
                                spacing={{ base: 4, md: 8, lg: 20 }}
                                direction={{ base: 'column', md: 'row' }}>
                                <Stack
                                    align="center"
                                    justify="space-around"
                                    direction={{ base: 'row', md: 'column' }}>
                                    <Tooltip
                                        label={hasCopied ? 'Email Copied!' : 'Copy Email'}
                                        closeOnClick={false}
                                        hasArrow>
                                        <IconButton
                                            aria-label="email"
                                            variant="ghost"
                                            size="lg"
                                            fontSize="3xl"
                                            icon={<MdEmail />}
                                            _hover={{
                                                bg: 'blue.500',
                                                color: useColorModeValue('white', 'gray.700'),
                                            }}
                                            onClick={onCopy}
                                            isRound
                                        />
                                    </Tooltip>

                                    <Tooltip
                                        label={hasCopiedMobile ? '+91 8668794792' : '+91 8668794792'}
                                        closeOnClick={false}
                                        hasArrow>
                                        <IconButton
                                            aria-label="mobile"
                                            variant="ghost"
                                            size="lg"
                                            fontSize="3xl"
                                            icon={<BsTelephoneFill />}
                                            _hover={{
                                                bg: 'blue.500',
                                                color: useColorModeValue('white', 'gray.700'),
                                            }}
                                            onClick={onCopyMobile}
                                            isRound
                                        />
                                    </Tooltip>


                                    <Link href="https://github.com/AshishKohad27" target="_blank">
                                        <IconButton
                                            aria-label="github"
                                            variant="ghost"
                                            size="lg"
                                            fontSize="3xl"
                                            icon={<BsGithub />}
                                            _hover={{
                                                bg: 'blue.500',
                                                color: useColorModeValue('white', 'gray.700'),
                                            }}
                                            isRound
                                        />
                                    </Link>

                                    <Link href="https://api.whatsapp.com/send?phone=%2B918668794792&text&app_absent=0" target="_blank">
                                        <IconButton
                                            aria-label="twitter"
                                            variant="ghost"
                                            size="lg"
                                            icon={<BsWhatsapp size="28px" />}
                                            _hover={{
                                                bg: 'blue.500',
                                                color: useColorModeValue('white', 'gray.700'),
                                            }}
                                            isRound
                                        />
                                    </Link>

                                    <Link href="https://www.linkedin.com/in/ashish-kohad27/" target="_blank">
                                        <IconButton
                                            aria-label="linkedin"
                                            variant="ghost"
                                            size="lg"
                                            icon={<BsLinkedin size="28px" />}
                                            _hover={{
                                                bg: 'blue.500',
                                                color: useColorModeValue('white', 'gray.700'),
                                            }}
                                            isRound
                                        />
                                    </Link>
                                </Stack>

                                <Box
                                    borderRadius="lg"
                                    p={8}
                                    bg={useColorModeValue('white', 'gray.700')}
                                    color={useColorModeValue('gray.700', 'whiteAlpha.900')}
                                    shadow="base">
                                    <VStack spacing={5}>
                                        {/* <FormControl isRequired>
                                            <FormLabel>Name</FormLabel>

                                            <InputGroup>
                                                <InputLeftElement children={<BsPerson />} />
                                                <Input type="text" name="name" placeholder="Your Name" />
                                            </InputGroup>
                                        </FormControl>

                                        <FormControl isRequired>
                                            <FormLabel>Email</FormLabel>

                                            <InputGroup>
                                                <InputLeftElement children={<MdOutlineEmail />} />
                                                <Input
                                                    type="email"
                                                    name="email"
                                                    placeholder="Your Email"
                                                />
                                            </InputGroup>
                                        </FormControl>

                                        <FormControl isRequired>
                                            <FormLabel>Message</FormLabel>

                                            <Textarea
                                                name="message"
                                                placeholder="Your Message"
                                                rows={6}
                                                resize="none"
                                            />
                                        </FormControl>

                                        <Button
                                            colorScheme="blue"
                                            bg="blue.400"
                                            color="white"
                                            _hover={{
                                                bg: 'blue.500',
                                            }}

                                            isFullWidth

                                        >
                                            Send Message
                                        </Button> */}

                                        <form ref={form} onSubmit={sendEmail}>
                                            <FormLabel>Name</FormLabel>
                                            <InputGroup>
                                                <InputLeftElement children={<BsPerson />} />
                                                <Input
                                                    placeholder="Name"
                                                    type="text" name="user_name" />
                                            </InputGroup>
                                            <FormLabel>Email</FormLabel>
                                            <InputGroup>
                                                <InputLeftElement children={<MdOutlineEmail />} />
                                                <Input
                                                    placeholder='Email'
                                                    type="email" name="user_email" />
                                            </InputGroup>
                                            <FormLabel>Subject</FormLabel>
                                            <InputGroup>
                                                <InputLeftElement children={<MdOutlineEmail />} />
                                                <Input
                                                    placeholder='Subject'
                                                    type="text" name="user_subject" />
                                            </InputGroup>

                                            <FormLabel>Message</FormLabel>
                                            <Textarea
                                                name="message"
                                                placeholder="Your Message"
                                            />


                                            <Input
                                                cursor="pointer"
                                                colorScheme="blue"
                                                bg="blue.400"
                                                color="white"
                                                _hover={{
                                                    bg: 'blue.500',
                                                }}
                                                fontSize="20px"
                                                fontWeight="bold"
                                                mt="20px"
                                                isFullWidth
                                                type="submit" value="Send Message"
                                                onClick={handleSend}
                                            />
                                        </form>
                                    </VStack>
                                </Box>
                            </Stack>
                        </VStack>
                    </Box>
                </Box>
            </Flex>
        </Box>

    );
}